// File: `app/javascript/controllers/product_module/rural_tourism.js`
import $ from 'jquery';
import flatpickr from 'flatpickr';
import {withElementBlock} from "../blockUI_controller";

export function initRuralTourism(deps = {}) {
    const {
        form_type_send,
        create_array_for_product,
        get_contract,
        modalities,
        modality_info,
        setSessionVar,
        date_disabled,
        flatpick_lang,
        I18n,
        location,
        sessionStorage
    } = deps;

    if (!form_type_send) return;

    const rural_tourism_to = $('#rural_tourism_to');
    const rural_tourism_service = $('#rural_tourism_service');
    const rural_tourism_date = $('#rural_tourism_date');
    const rural_tourism_cantidad = $('#rural_tourism_cantidad');
    const rural_tourism_observaciones = $('#rural_tourism_observaciones');
    let rural_btn_info_desc = '';

    // Estado inicial
    rural_tourism_service.prop('disabled', true).select2({
        theme: 'bootstrap',
        placeholder: I18n.t('global.main.form.select_service')
    });
    rural_tourism_date.prop('disabled', true);
    rural_tourism_cantidad.prop('disabled', true);
    rural_tourism_observaciones.prop('disabled', true);

    // Destinos
    rural_tourism_to.select2({
        theme: "bootstrap",
        placeholder: I18n.t('global.main.form.select_destiny'),
        ajax: {
            url: '/destination',
            dataType: "json",
            language: "es",
            data: function (params) {
                return {
                    form_type: form_type_send.val(),
                    search: params.term,
                    page: params.page || 1
                }
            },
            type: 'GET',
            processResults: function (data, params) {
                const result = [];
                params.page = params.page || 1;
                (data.rows || []).map(elem => {
                    result.push({
                        id: `${elem.code}|${elem.id}|${elem.name}`,
                        text: elem.name
                    })
                });
                const total = data.total || 0;
                return {
                    results: result,
                    pagination: { more: total > 10 && ((parseInt(total) - (10 * parseInt(params.page || 1))) > 1) }
                };
            }
        }
    }).on('change', function (e) {
        rural_btn_info_desc = '';
        const parts = (e.target.value || '').split('|');
        const destino_id = parts[1] || '';

        create_array_for_product('product_type', form_type_send.val());
        create_array_for_product('destination_id', destino_id);
        create_array_for_product('destination_code', parts[0] || '');
        create_array_for_product('text_destination', parts[2] || '');

        // limpiar
        rural_tourism_service.empty();
        rural_tourism_date.val('');
        rural_tourism_cantidad.val('');
        rural_tourism_observaciones.val('');

        // Servicios por dealer
        rural_tourism_service.prop('disabled', false).select2({
            theme: "bootstrap",
            placeholder: I18n.t('global.main.form.select_service'),
            ajax: {
                url: `${location.origin}/${sessionStorage.getItem('locale')}/service_by_dealer`,
                data: function (params) {
                    return {
                        search: params.term,
                        page: params.page || 1,
                        destination: destino_id,
                        form_type: form_type_send.val()
                    }
                },
                type: 'GET',
                processResults: function (data, params) {
                    const result = [];
                    params.page = params.page || 1;
                    (data.services || []).map(elem => {
                        result.push({
                            id: [
                                elem.id,
                                elem.code,
                                elem.reservation_time,
                                data.dealer_code,
                                data.dealer_name,
                                data.dealer_id,
                                elem.min_reservation_amount,
                                elem.max_reservation_amount
                            ].join("|"),
                            text: elem.name
                        })
                    });
                    const total = data.total || 0;
                    return {
                        results: result,
                        pagination: { more: total > 10 && ((parseInt(total) - (10 * parseInt(params.page || 1))) > 1) }
                    };
                }
            }
        }).on('change', function (e) {
            rural_tourism_date.prop('disabled', false);
            rural_tourism_cantidad.prop('disabled', false);
            rural_tourism_observaciones.prop('disabled', false);
            rural_btn_info_desc = '';

            const product_type = (e.target.value || '').split("|");
            const product_name = (e.target.selectedOptions && e.target.selectedOptions[0] && e.target.selectedOptions[0].innerHTML || '').toLowerCase();

            create_array_for_product('category_id', product_type[0]);
            create_array_for_product('category_code', product_type[1]);
            create_array_for_product('dealer_code', product_type[3]);
            create_array_for_product('dealer_name', product_type[4]);
            create_array_for_product('dealer_id', product_type[5]);

            // FIX (2026-08-10): contrato con bloqueo + desbloqueo garantizado.
            withElementBlock('box-form', I18n.t('global.main.form.message.search_contract'), get_contract('box-form')).then(gcontract => {
                if (!gcontract.next) return;
            });

            // Obtener modalidades y detalle de modalidad por defecto
            withElementBlock('box-form', I18n.t('global.main.form.message.loading_data'),
                modalities(product_type[0], product_type[5]),
                { timeout: 30000 }
            ).then(mdlt => {
                const modalities_name = (mdlt && mdlt.rows && mdlt.rows[0]) ? mdlt.rows[0] : '';
                if (modalities_name) {
                    let name = modalities_name;
                    const split_modality = name.split(' ');
                    if (split_modality[split_modality.length - 1] === 'POR') {
                        name = split_modality.slice(0, -1).join(' ');
                    }
                    create_array_for_product('modalities_name', name);

                    withElementBlock('box-form', I18n.t('global.main.form.message.loading_data'),
                        modality_info(product_type[5], product_type[0], name),
                        { timeout: 30000 }
                    ).then(modality => {
                        if (modality && modality.data && modality.data[0]) {
                            create_array_for_product('modality_code', modality.data[0].code);
                        }
                        if (modality && modality.calc_amount !== undefined) {
                            create_array_for_product('calc_amount', modality.calc_amount);
                        }

                        if (modality) {
                            rural_tourism_cantidad[0].setAttribute('data-min', modality.min || 1);
                            rural_tourism_cantidad[0].setAttribute('data-max', (modality.max || 1) + 20);

                            // comportamiento según has_pax / info
                            if (modality.info === 'true' && modality.has_pax) {
                                // lógica opcional para mostrar/ocultar inputs si hace falta
                            } else {
                                // alternativa si no tiene pax
                            }
                        }
                    })
                }
            });

            // Calendario
            flatpickr(rural_tourism_date, {
                altInput: true,
                altFormat: "d-m-Y",
                dateFormat: "Y-m-d",
                disable: date_disabled,
                minDate: new Date().fp_incr(parseInt(product_type[2] || 0)),
                maxDate: new Date().fp_incr(90),
                locale: flatpick_lang
            });

            rural_tourism_date.off('change').on('change', function (ev) {
                // Guardar fechas en session y en array de producto
                setSessionVar('from_date', ev.target.value, 'add', true, false).then(from => {
                    create_array_for_product('from_date', from.value);
                });
                setSessionVar('to_date', ev.target.value, 'add', true, false, 1).then(to => {
                    create_array_for_product('to_date', to.value);
                });
            });
        });
    });
}


/* Antes de dividir */
/*
let rural_tourism_to, rural_tourism_service, rural_tourism_date, rural_tourism_cantidad,
    rural_tourism_observaciones;
rural_tourism_to = $('#rural_tourism_to');
rural_tourism_service = $('#rural_tourism_service');
rural_tourism_date = $('#rural_tourism_date');
rural_tourism_cantidad = $('#rural_tourism_cantidad');
rural_tourism_observaciones = $('#rural_tourism_observaciones');
rural_tourism_service.prop('disabled', true).select2({
    theme: 'bootstrap',
    placeholder: I18n.t('global.main.form.select_service')
});
rural_tourism_date.prop('disabled', true);
rural_tourism_cantidad.prop('disabled', true);
rural_tourism_observaciones.prop('disabled', true);

rural_tourism_to.select2({
    theme: "bootstrap",
    placeholder: I18n.t('global.main.form.select_destiny'),
    ajax: {
        url: '/destination',
        dataType: "json",
        language: "es",
        data: function (params) {
            return {
                form_type: form_type_send.val(),
                search: params.term,
                page: params.page || 1
            }
        },
        type: 'GET',
        processResults: function (data, params) {
            let result = [];
            params.page = params.page || 1;

            data.rows.map((elem, key) => {
                result.push({
                    id: elem.code + '|' + elem.id + '|' + elem.name,
                    text: elem.name
                })
            })

            if (data.total > 10) {
                if ((parseInt(data.total) - (10 * parseInt(params.page))) > 1) {
                    return {
                        results: result,
                        "pagination": {
                            "more": true
                        }
                    }
                } else {
                    return {
                        results: result,
                        "pagination": {
                            "more": false
                        }
                    }
                }
            } else {
                return {
                    results: result,
                    "pagination": {
                        "more": false
                    }
                }
            }
        }
    }
}).on('change', function (e) {
    let data_rural_tourism_to = e.target.value.split("|")[1];
    create_array_for_product('product_type', form_type_send.val());
    create_array_for_product('destination_id', e.target.value.split("|")[1]);
    create_array_for_product('destination_code', e.target.value.split("|")[0]);
    create_array_for_product('text_destination', e.target.value.split("|")[2]);

    rural_tourism_service.empty();
    rural_tourism_date.empty();
    rural_tourism_cantidad.empty();
    rural_tourism_observaciones.empty();

    rural_tourism_service.prop('disabled', false).select2({
        theme: "bootstrap",
        placeholder: I18n.t('global.main.form.select_service'),
        ajax: {
            url: `${location.origin}/${sessionStorage.getItem('locale')}/service_by_dealer`,
            data: function (params) {
                return {
                    search: params.term,
                    page: params.page || 1,
                    destination: data_rural_tourism_to,
                    form_type: form_type_send.val()
                }
            },
            type: 'GET',
            processResults: function (data, params) {
                let result = [];
                params.page = params.page || 1;
                data.services.map((elem, key) => {
                    result.push({
                        id: elem.id + "|" + elem.code + "|" + elem.reservation_time + "|" + data.dealer_code + "|" + data.dealer_name + "|" + data.dealer_id + "|" + elem.min_reservation_amount + "|" + elem.max_reservation_amount,
                        text: elem.name
                    })
                })

                if (data.total > 10) {
                    if ((parseInt(data.total) - (10 * parseInt(params.page))) > 1) {
                        return {
                            results: result,
                            "pagination": {
                                "more": true
                            }
                        }
                    } else {
                        return {
                            results: result,
                            "pagination": {
                                "more": false
                            }
                        }
                    }
                } else {
                    return {
                        results: result,
                        "pagination": {
                            "more": false
                        }
                    }
                }
            }
        }
    }).on('change', function (e) {
        rural_tourism_date.prop('disabled', false);
        rural_tourism_cantidad.prop('disabled', false);
        rural_tourism_observaciones.prop('disabled', false);

        let product_type = e.target.value.split("|");
        let product_name = '';
        product_name = e.target.selectedOptions[0].innerHTML.toLowerCase();

        create_array_for_product('category_id', product_type[0]);
        create_array_for_product('category_code', product_type[1]);
        create_array_for_product('dealer_code', product_type[3]);
        create_array_for_product('dealer_name', product_type[4]);
        create_array_for_product('dealer_id', product_type[5]);

        get_contract().then(
            contract => {
                // console.log(contract);
            }
        )

        modalities(product_type[0], product_type[5]).then(
            mdlt => {
                /!* REVISAR LUEGO POR EL TEMA DEL NOMBRE DE LA MODALIDAD ESTA PUESTO 'FINCA EL FRUTAL POR PAX' *!/
                let modalities_name = mdlt.rows[0];
                let split_modality = modalities_name.split(' ');
                if (split_modality[split_modality.length - 1] === 'POR') {
                    modalities_name = split_modality.slice(0, -1).join(' ');
                }
                create_array_for_product('modalities_name', modalities_name);

                modality_info(product_type[5], product_type[0], modalities_name).then(
                    modality => {
                        create_array_for_product('modality_code', modality.data[0].code);
                        create_array_for_product('calc_amount', modality.calc_amount);

                        rural_tourism_cantidad[0].setAttribute('data-min', modality.min);
                        rural_tourism_cantidad[0].setAttribute('data-max', modality.max + 20);

                        if (modality.info === 'true') {
                            if (modality.has_pax) {
                                /!* OCULTANDO Y MOSTRANDO INPUTS EN DEPENDENCIA DE LO QUE NOS DEVUELVA EL SERVICIO *!/
                                /!* excursion_pax_block[0].classList.add('ocultar');
                                 excursion_cantidad_block[0].classList.add('ocultar');
                                 excursion_adult_childrens[0].classList.remove('ocultar');*!/

                                /!* SETEANDO ATRIBUTOS A LOS INPUTS PARA EVALUAR *!/
                                /!*excursion_adultos[0].setAttribute('data-min', modality.min);
                                let min = 1;
                                if ((parseInt(modality.min) - 1) <= 0) {
                                    min = 0
                                }
                                excursion_childrens[0].setAttribute('data-min', min)
                                excursion_adultos[0].setAttribute('data-max', modality.max);
                                excursion_childrens[0].setAttribute('data-max', (parseInt(modality.max) - 1))
                                excursion_adultos[0].setAttribute('data-evaluate-max', modality.max);
                                excursion_childrens[0].setAttribute('data-evaluate-max', modality.max)

                                create_array_for_product('day_min_rent', min);
                                create_array_for_product('day_max_rent', modality.max);*!/
                            } else {
                                /!*excursion_pax_block[0].classList.remove('ocultar');
                                excursion_cantidad_block[0].classList.add('ocultar');
                                excursion_adult_childrens[0].classList.add('ocultar');
                                excursion_pax.prop('disabled', false);*!/
                            }
                        }
                    }
                )
            }
        )

        flatpickr(rural_tourism_date, {
            altInput: true,
            altFormat: "d-m-Y",
            dateFormat: "Y-m-d",
            disable: date_disabled,
            minDate: new Date().fp_incr(parseInt(product_type[2])),
            maxDate: new Date().fp_incr(90),
            locale: flatpick_lang
        });

        rural_tourism_date.on('change', function (e) {
            /!* SETEANDO FECHA EN QUE EMPIEZA Y TERMINA LA EXCURSION *!/
            setSessionVar('from_date', e.target.value, 'add', true, false).then(
                from => {
                    create_array_for_product('from_date', from.value);
                }
            );
            setSessionVar('to_date', e.target.value, 'add', true, false, 1).then(
                to => {
                    create_array_for_product('to_date', to.value);
                }
            );
        })
    })
})*/
